<h1 class="title">Financial</h1>
<h5>Manage Financial Settings and Preferences</h5>
<div class="cas-wrapper">
    <form [formGroup]="settings" *ngIf="!isLoading else loadingView" class="cas-flex-row">
        <acabim-form-block labelWidth="6" [labelAlign]="'right'" [colonize]="true" [shortFields]="true" class="w-100" style="margin-bottom: -2rem;">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Enable</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox formControlName="enable_financial" [binary]="true"></p-checkbox>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
        <ng-container *ngIf="settings.get('enable_financial').value">
            <acabim-card cardHeading="Reporting" [cardContent]="reporting" class="col-md-6 push-down-2"></acabim-card>
            <acabim-card cardHeading="Payments" [cardContent]="payments" class="col-md-6 push-down-2"></acabim-card>
            <acabim-card cardHeading="Currency and tax" [cardContent]="currency" class="col-md-6 push-down-2"></acabim-card>
            <acabim-card cardHeading="Contingency fund" [cardContent]="contingencyFund" class="col-md-6 push-down-2"></acabim-card>
            <acabim-card cardHeading="Maintenance items" [cardContent]="maintenanceItems" class="col-md-6 push-down-2"></acabim-card>
        </ng-container>
    </form>
    <div class="cas-action-buttons">
        <button
                data-cy="_t-update-fin-org-settings"
                class="cas-button-action"
                (click)="onSubmit()">Update</button>
    </div>
</div>

<ng-template #reporting>
    <form [formGroup]="settings">
        <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Reporting period</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        appendTo="body"
                        formControlName="period"
                        [options]="periods"
                        placeholder="Select Period"
                        optionLabel="name"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Start Date</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-calendar
                        formControlName="startDate"
                        dateFormat="dd/mm/y"
                        appendTo="body"
                        readonlyInput="true"
                        #calendar></p-calendar>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
    </form>
</ng-template>

<ng-template #contingencyFund>
    <form [formGroup]="settings">
        <acabim-form-block labelWidth="12" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Contingency account</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox formControlName="contingency" [binary]="true"></p-checkbox>
                    <p-dropdown
                        *ngIf="showContingencyAccounts"
                        appendTo="body"
                        formControlName="contingencyFund"
                        placeholder="Select Account"
                        [group]="true"
                        [options]="accounts"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
    </form>
</ng-template>

<ng-template #maintenanceItems>
    <form [formGroup]="settings">
        <acabim-form-block labelWidth="12" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Maintenance items</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox formControlName="maintenanceItems" [binary]="true"></p-checkbox>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
    </form>
</ng-template>

<ng-template #propertyLease>
    <form [formGroup]="settings">
        <acabim-form-block labelWidth="12" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Rent/lease payment account</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox formControlName="propLeaseRentPayment" [binary]="true"></p-checkbox>
                    <p-dropdown
                            *ngIf="showRentPaymentAccounts"
                            appendTo="body"
                            formControlName="propLeaseRentPaymentAccount"
                            [group]="true"
                            [options]="accounts"
                            placeholder="Select Account"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Rent/lease income account</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-checkbox formControlName="propLeaseRentIncome" [binary]="true"></p-checkbox>
                    <p-dropdown
                            *ngIf="showRentIncomeAccounts"
                            appendTo="body"
                            formControlName="propLeaseRentIncomeAccount"
                            [group]="true"
                            [options]="accounts"
                            placeholder="Select Account"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
    </form>
</ng-template>

<ng-template #payments>
    <form [formGroup]="settings">
        <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Interval</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        appendTo="body"
                        formControlName="interval"
                        [options]="intervalTypes"
                        placeholder="Select Interval"
                        optionLabel="name"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Interval value</acabim-form-input-label>
                <acabim-form-input-content>
                    <input type="number" formControlName="intervalValue" />
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
    </form>
</ng-template>

<ng-template #currency>
    <form [formGroup]="settings">
        <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Currency</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        appendTo="body"
                        formControlName="currency"
                        [options]="defaultCurrency"
                        placeholder="Select Currency"
                        optionLabel="name"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Default tax</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        appendTo="body"
                        formControlName="tax"
                        [options]="taxType"
                        placeholder="Select Tax"
                        optionLabel="name"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
    </form>
</ng-template>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<p-toast position="center"></p-toast>
